import type { ComponentProps } from "react"

import { cn } from "@productlane/lib/src/cn"
import { ScrollArea, ScrollViewport } from "@productlane/ui"

type Props = ComponentProps<"div">

export function ProjectOrIssueListWrapper({
	className,
	children,
	...props
}: Props) {
	return (
		<div className={cn("min-h-0 flex-1", className)} {...props}>
			<ScrollArea>
				<ScrollViewport>{children}</ScrollViewport>
			</ScrollArea>
		</div>
	)
}
